export const validation = {
  titleMaxChar: 30,
  paragraphMaxChar: 200,
  blocks: {
    min: 1,
    max: 3,
    title: { required: true }
  }
}
